import React, { useEffect } from "react";
import { ContainerFluid } from "../../../../common/styles";
import {
    Body,
    CardExpenseRedesigned,
    CardExpenseTitle,
    ContainerStyle,
    Title,
} from "./index.style";
import { CustomBadge } from "../../../../components/Badge";
import { Flex, Loader, Table } from "@fluentui/react-northstar";
import { header } from "./constants";
import HistoryPaidExpenses from "../../components/HistoryPaidExpenses/HistoryPaidExpenses";
import { _api_get_list_to_verify_expenses } from "../../api";
import EmptyExpensesToPaid from "./EmptyExpensesToPaid";
import useLogic from "./useLogic";
import Toast from "../../../../components/Alerts";
import { SIZES } from "../../../../constants/responsive";
import { useMediaQuery } from "react-responsive";
import FilterExpensesForm from "./FilterExpensesForm";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import ChartSection from "../../components/ChartSection";
import { ROLES, ROLES_CODE } from "../../../../constants/roles";
import { ROUTES } from "../../../../constants/routes";
import { ROUTES_SEPARATOR } from "../../../../constants";
import { useAuthDetailStore } from "../../../../stores/useAuthStore";

const ExpensesAccountingManagerHome = () => {
    // IMPORT LOGIC
    const [searchParams, setSearchParams] = useSearchParams();
    const { detail } = useAuthDetailStore();
    const navigate = useNavigate();
    const { role } = useParams();

    // le role doit etre "accounting_manager" ou bien "ceo"
    useEffect(() => {
        if (
            role !== ROLES_CODE.ceo.toLowerCase() &&
            role !== ROLES_CODE.accounting_manager.toLowerCase()
        ) {
            const redirection_route =
                ROUTES.expenses.home +
                ROUTES_SEPARATOR +
                ROUTES.expenses.accounting_manager.home.custom_route(() =>
                    ROLES_CODE.accounting_manager.toLowerCase()
                );
            return navigate(redirection_route);
        }
        // doit avoir Role CEO
        if (
            !detail.roles.map((r) => r.code).includes(ROLES_CODE.ceo) &&
            role === ROLES_CODE.ceo.toLowerCase()
        ) {
            return navigate("/denied");
        }
    }, [role, setSearchParams]);

    const enable =
        (searchParams.get("r") !== null || searchParams.get("r") !== "") &&
        (searchParams.get("ec") !== null || searchParams.get("ec") !== "") &&
        (searchParams.get("m") !== null || searchParams.get("m") !== "") &&
        (searchParams.get("ud") !== null || searchParams.get("ud") !== "") &&
        (searchParams.get("sd") !== null || searchParams.get("sd") !== "") &&
        (searchParams.get("ed") !== null || searchParams.get("ed") !== "");

    const { rows, query, toast } = useLogic({ enabled: enable });

    const isMobileS = useMediaQuery({
        query: `(max-width: ${SIZES.mobileM})`,
    });
    const isMobileM = useMediaQuery({
        query: `(max-width: ${SIZES.mobileL})`,
    });
    const isMobileL = useMediaQuery({
        query: "(max-width: 450px)",
    });

    const isMobile = isMobileS || isMobileM || isMobileL;

    return (
        <ContainerFluid>
            <ContainerStyle styles={{ marginTop: "24px" }}>
                <Flex>
                    <Toast
                        visible={toast.show.visible}
                        content="Note de frais approuvée"
                        level="success"
                        onStatusChange={() => {
                            toast.setShow((prev) => ({
                                ...prev,
                                visible: false,
                            }));
                        }}
                    />
                </Flex>
                <Body gap="gap.large" styles={{ marginTop: "24px" }}>
                    {/* LEFT SECTION */}
                    <Flex
                        column
                        gap="gap.medium"
                        styles={{ width: "fit-content" }}
                    >
                        <Title>Notes de frais de l'entreprise</Title>
                        {/* filtres */}
                        <FilterExpensesForm />
                        <CardExpenseRedesigned column gap="gap.medium">
                            {/* title + badge */}
                            <Flex vAlign="center" gap="gap.small">
                                <CardExpenseTitle>
                                    Notes à payer
                                </CardExpenseTitle>
                                <CustomBadge
                                    bg="orange"
                                    color="white"
                                    label={query.data?.length?.toString()}
                                    size="smaller"
                                />
                            </Flex>
                            {/* TABLE EXPENSES */}

                            {query.isLoading ? (
                                <Loader label={"chargement des notes ..."} />
                            ) : (
                                <Table
                                    header={!isMobile && header}
                                    rows={rows}
                                    aria-label="list"
                                />
                            )}

                            {rows.length === 0 && <EmptyExpensesToPaid />}
                        </CardExpenseRedesigned>
                    </Flex>
                    <Flex column gap="gap.large">
                        <ChartSection role="accounting_manager" />
                        {/* RIGHT SECTION */}
                        <HistoryPaidExpenses />
                    </Flex>
                </Body>
            </ContainerStyle>
        </ContainerFluid>
    );
};

export default ExpensesAccountingManagerHome;
